import { app } from '../main'
import * as types from './mutation-types'
import axios from 'axios'

export const state = {
	user: {},
	userPref: {},
	role: '',
	search_input: '',
	token: null,
	loggedIn: false,
	lang: 'hu',
	currencies: { usd: null, eur: null, huf: null },
	filters: {
		isBiddedProductsSwitched: false,
		isFavoritesProductsSwitched: false,
		isUploadedProductsSwitched: false,
		isFinishedProductsSwitched: true,
		category: null,
		countries: [],
		counties: [],
		cities: [],
		tags: [],
		keyword: '',
		page: 1,
	},
	params: {
		countries: [],
		tags: [],
		dates: [],
		cities: [],
	},
}

export const mutations = {
	[types.SET_LANG](state, payload) {
		app.$i18n.locale = payload
	},
	setUser(state, user) {
		state.user = user
		state.loggedIn = true
		//console.log('!!!!!!!!!', user);
	},
	setRole(state, payload) {
		state.role = payload
		state.loggedIn = true
		//console.log('!!!!!!!!!', user);
	},
	setFilters(state, filters) {
		state.filters = filters
	},
	setParams(state, params) {
		state.params = params
	},
	setToken(state, token) {
		state.token = token
		axios.defaults.headers.common['Authorization'] = token
	},
	setLoggedIn(state, loggedIn) {
		state.loggedIn = loggedIn
	},
	setSearchInput(state, text) {
		state.search_input = text
	},
	setCurrencies(state, data) {
		state.currencies = data
	},
	setCountry(state, payload) {
		state.params.counties = payload
	},
	setCity(state, payload) {
		state.filters.city = payload
	},
	setTags(state, payload) {
		state.params.tags = payload
	},
	setDates(state, payload) {
		state.params.dates = payload
	},
}

export const getters = {
	username: (state) => state.user.email,
	bidder_name: (state) => (state.user.UserPreference ? state.user.UserPreference.name : state.user.bidder_name),
	lang: (state) => (state.user.UserPreference ? state.user.UserPreference.language : 'hu'),
	userid: (state) => state.user.id,
	token: (state) => state.token,
	loggedIn: (state) => state.loggedIn,
	searchInput: (state) => state.searchInput,
	currencies: (state) => state.currencies,
	userpref: (state) => state.user.UserPreference,
	role: (state) => state.role,
	getFilters: (state) => state.filters,
	getParams: (state) => state.params,
}

export const actions = {
	// setLang(context, payload) {
	//   context.commit(types.SET_LANG, payload)
	// }
	setLang({ commit }, payload) {
		commit(types.SET_LANG, payload)
	},
	// setLangNew({commit}, payload){
	//   if (payload in app.$i18n.messages) {
	//     commit(types.SET_LANG, payload)
	//   } else {
	//     fetch(`./src/lang/${payload}.json` , {
	//     method: 'get',
	//     headers: {
	//       'Accept': 'application/json',
	//       'Content-Type': 'application/json'
	//     }
	//   }).then((res) => {
	//     console.log('success');
	//       return res.json()
	//     }).then((json) => {
	//       if (Object.keys(json).length === 0) {
	//         return Promise.reject(new Error('locale empty !!'))
	//       } else {
	//         return Promise.resolve(json)
	//       }
	//     }).then((message) => {
	//       app.$i18n.setLocaleMessage(payload, message)
	//       commit(types.SET_LANG, payload)
	//     }).catch((error) => {
	//       console.log(error)
	//     })
	//   }
	// },
	// setLangNew({commit}, payload){
	//   if (payload in app.$i18n.messages) {
	//     commit(types.SET_LANG, payload)
	//   } else {
	//    axios.get(`./src/lang/${payload}.json`)
	//     .then((res) => {
	//       app.$i18n.setLocaleMessage(payload, res.data)
	//       commit(types.SET_LANG, payload)
	//     })
	//     .catch((error) => {
	//       console.log(error)
	//     })
	//   }
	// }

	async setLangNew({ commit }, payload) {
		if (payload in app.$i18n.messages) {
			commit(types.SET_LANG, payload)
		} else {
			try {
				const res = await axios.get(`./src/lang/${payload}.json`)
				// const res = await axios.get(`../../src/lang/${payload}.json`)
				// const res = await import(`./src/lang/${payload}.json`)
				app.$i18n.setLocaleMessage(payload, res.data)
				commit(types.SET_LANG, payload)
			} catch (e) {
				console.log(e)
			}
		}
	},
}
